import { render, staticRenderFns } from "./OrdersToProducts.vue?vue&type=template&id=fb7f5300"
import script from "./OrdersToProducts.vue?vue&type=script&lang=js"
export * from "./OrdersToProducts.vue?vue&type=script&lang=js"
import style0 from "./OrdersToProducts.vue?vue&type=style&index=0&id=fb7f5300&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports